/**
 * Adzuki.MaxxAnimations — the Maxx loading animations, in one place.
 *
 * Every feature that makes an advisor wait plays one of these, and until now
 * each kept its own copy of the list: Ask Maxx (chatbot.js), Maxx Assist
 * (workspace.js), AI Cruise Search (ErezAiCruiseSearchForm.js) and the Home
 * Office data chat (chat_with_data.js). Four copies of one list drift, and they
 * had: AI Cruise Search carried luggage, hangglider, surfing and zipline that
 * the other three had never heard of, so the same product showed a different
 * set of animations depending on which screen you were waiting on.
 *
 *     $img.attr('src', Adzuki.MaxxAnimations.random());
 *
 * ADDING ONE: drop the .gif in the shared images directory and add its filename
 * to FILES below. That is the whole change — every consumer picks it up.
 *
 * NOT in this list, deliberately, and they should stay out:
 *   maxx-listening.gif  the microphone is live, a STATE rather than a wait
 *   maxx-thinking.gif   the fixed image on the two GPT prompt screens
 * Both mean something specific. A random cycle would say the wrong thing.
 *
 * Lives in js/Adzuki/ because that is the core bundle every app loads, and it
 * is a dir-level file so it is concatenated ahead of js/Adzuki/components/.
 * Call sites still guard on it the way they guard Adzuki.VoiceInput — a missing
 * animation should cost an image, never a thrown error inside a chat bubble.
 */
(function MaxxAnimations($, Adzuki)
{
	"use strict";

	// Filenames only. The directory is resolved at call time, because base_uri
	// differs per environment and per developer folder on dev.
	var FILES = [
		'maxx-thinking-animation.gif',
		'maxx-playing-animation.gif',
		'maxx-running-animation.gif',
		'maxx-scooter.gif',
		'maxx-rowing.gif',
		'maxx-driving.gif',
		'maxx-luggage.gif',
		'maxx-hangglider.gif',
		'maxx-surfing.gif',
		'maxx-zipline.gif',
		'maxx-bicycle.gif',
		'maxx-horse.gif',
		'maxx-skateboard.gif',
		'maxx-sportscar.gif',
	];

	var animations = {};

	/**
	 * A copy, so a caller cannot reorder or empty the list for everyone else.
	 */
	animations.files = function files()
	{
		return FILES.slice();
	};

	/**
	 * Filename to a full URL. Public so a caller that already holds a specific
	 * filename does not have to know where the images live either.
	 */
	animations.url = function url(file)
	{
		return (Adzuki.base_uri || '') + '/images/' + file;
	};

	animations.randomFile = function randomFile()
	{
		return FILES[Math.floor(Math.random() * FILES.length)];
	};

	/**
	 * The one every caller wants: a ready-to-use src for a different animation
	 * each time, so a wait feels alive rather than frozen.
	 */
	animations.random = function random()
	{
		return animations.url(animations.randomFile());
	};

	Adzuki.MaxxAnimations = animations;
}(jQuery, window.Adzuki || {}));
